// 1 - Inove  2 - Administrador  3 - Utilizador  4 - Utente
const _GROUPS = {
  super: [1],
  not_super: [2, 3, 4],
  full_access: [1, 2, 3, 4],
  only_super: [1, 2],
  user: [1, 2, 3],
  only_user: [3, 4]
}

const _COMPONENTS = {
  home: _GROUPS.full_access,
  galardao: _GROUPS.super,
  galardao_pedido: _GROUPS.user,
  utilizador_colheita: _GROUPS.only_super,
  associado: _GROUPS.only_super,
  instituicao: _GROUPS.super,
  donativo: _GROUPS.user,
  utilizador: _GROUPS.only_super,
  brigada: _GROUPS.full_access,
  colheita: _GROUPS.full_access,
  dadiva: _GROUPS.only_super,
  PickerInstituicao: _GROUPS.only_super
}

const _HASPERMISSION = (component, type) => {
  if (!type || !component) return false

  return (
    typeof _COMPONENTS[component] != "undefined" &&
    _COMPONENTS[component].findIndex(el => {
      return el == Number(type)
    }) > -1
  )
}

const _ISALLOWED = (group, type) => {
  if (!type || !group) return false

  return (
    typeof group != "undefined" &&
    group.findIndex(el => {
      return el == Number(type)
    }) > -1
  )
}

const _ISDISABLED = (group, type) => {
  if (!type || !group) return false

  return (
    typeof group != "undefined" &&
    group.findIndex(el => {
      return el == Number(type)
    }) > -1
  )
}

const _ISSUPER = type => {
  if (!type) return false

  return (
    _GROUPS.super.findIndex(el => {
      return el == Number(type)
    }) > -1
  )
}

export { _GROUPS, _HASPERMISSION, _ISALLOWED, _ISDISABLED, _ISSUPER }
